import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TSL_DIALOG_DATA, TslCheckboxChange, TslDialogRef } from '@tesla/ng-tds';
import { I18nService } from 'app/shared/services/i18n.service';
import { PcfDialogComponent } from '../pcf-dialog/pcf-dialog.component';
import { onMFAEnrollmentClick } from 'app/shared/utils/utils';
import { AuthData } from '@tesla/ng-auth';
import { AppSettings } from 'app/app.settings';
import { LanguageService } from 'app/core/services/language.service';
import { Subscription } from 'rxjs';
import { MfaDeclinedReasons, SupplierContact, SupplierContactPropertyValue, SupplierDocument } from 'app/profile/models/supplier.model';
import { isArray } from 'underscore';
import { UserDetails } from 'app/profile/models/user.model';
import { Store } from '@ngrx/store';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { GetSupplierContactListByCode } from 'app/profile/store/actions/supplierstate.action';
import { ContactsService } from 'app/profile/services/contacts.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-mfa-banner',
    templateUrl: './mfa-banner.component.html',
    styleUrls: ['./mfa-banner.component.scss'],
})
export class MfaBannerComponent implements OnInit {
    showSubmitAction: boolean = false;
    supplierCode: string;
    language: string;
    languageSub: Subscription;
    showCommentField: boolean = false;
    declineReasonsSelected: string[] = [];
    otherComment: string = null;
    isPCFValid: boolean = false;
    pcfDocument: SupplierDocument = null;
    showDeclineTab: boolean = false;
    contacts: SupplierContact[];
    showPCFOption: boolean = false;
    showFLMessage: boolean = false;
    pcfError: boolean = false;
    supplierContacts: SupplierContactPropertyValue[];
    constructor(
        public dialogRef: TslDialogRef<MfaBannerComponent>,
        @Inject(TSL_DIALOG_DATA) public data: any,
        private translate: I18nService,
        private store: Store<SupplierState>,
        private matDialog: MatDialog,
        private languageService: LanguageService,
        private authData: AuthData,
        private snackBar: MatSnackBar,
        private contactsService: ContactsService,
        private configuration: AppSettings,
    ) {}

    ngOnInit(): void {
        if (this.data) {
            this.supplierCode = this.data.supplierCode;
            this.supplierContacts = this.data.supplierContacts;
        }
        this.languageSub = this.languageService
            .getSelectedLanguageAsync()
            .subscribe((res) => (this.language = res || 'en-US'));
        let currentContact = this.supplierContacts.find(
            (x) => x.email?.newValue?.toLocaleLowerCase() == this.authData.getUserInfo().email.toLocaleLowerCase(),
        );
        let isPrimary = currentContact.types?.newValue?.includes('Primary');
        let isFinanceLead = currentContact.types?.newValue?.includes('Finance Lead');
        if (isPrimary == false || currentContact?.documents?.newValue?.length > 0) {
            this.showPCFOption = false;
        } else {
            this.showPCFOption = isPrimary;
        }

        if(isPrimary == false && isFinanceLead == true){
          this.showFLMessage = true;
        }

        this.showDeclineTab = isPrimary || isFinanceLead;
    }

    closeDialog() {
        this.dialogRef.close(false);
    }

    reasonSelected(event: TslCheckboxChange, reason: string, isOther: boolean) {
        if (event.checked) {
            this.declineReasonsSelected.push(reason);
        } else {
            this.declineReasonsSelected = this.declineReasonsSelected.filter((x) => x != reason);
        }

        if (isOther) {
            this.showCommentField = event.checked;
            if (event.checked == false) {
                this.otherComment = null;
            }
        }
    }

    onSubmit() {
        let validForm =
            this.declineReasonsSelected?.length > 0 &&
            (this.showCommentField == false || this.otherComment?.trim()?.length > 0) &&
            (this.showPCFOption == false || this.isPCFValid == true);
        if (validForm) {
          let mfaDeclinedReasons = new MfaDeclinedReasons();
          mfaDeclinedReasons.DeclinedReasons = this.declineReasonsSelected;
          mfaDeclinedReasons.Comment = this.otherComment?.trim();

            if(this.showPCFOption){
              // submit reasons along with Pcf changes
              this.contacts.forEach(con => {
                con["mfaDeclinedComment"] = mfaDeclinedReasons.Comment;
                con["mfaDeclinedReasons"] = mfaDeclinedReasons.DeclinedReasons;
              });
              this.contactsService.processContactChange(this.supplierCode, this.contacts, [this.pcfDocument]).subscribe(evtResult => {
                if (evtResult) {
                  if (evtResult.messages && evtResult.messages.filter(x => x.status === 'Error').length === 0) {
                    this.snackBar.open('Success!', null, {
                      duration: 5000,
                      verticalPosition: 'top',
                      panelClass: ['blue-snackbar']
                    });
                  } else {
                    console.log('Error occurred while posting contact change event.', evtResult.messages);
                    this.ShowError('Error', 'Error occurred while changing contact');
                  }
                }
                else {
                  console.log('Error occurred while posting contact change event.', evtResult.messages);
                  this.ShowError('Error', 'Error occurred while posting contact change');
                }
              }, err => {
                console.error(`Service call error: processContactChange service call could not be completed. Details: ` + err);
                this.ShowError("Error", JSON.parse(err.Message).error.message);
              },
                () => {
                  // TO clear or temporary changes on grid when error occurs
                  this.store.dispatch(new GetSupplierContactListByCode(this.supplierCode, true));
                  this.dialogRef.close(true);
                });
            }else{
              this.contactsService.processMFADeclinedReasons(this.supplierCode, mfaDeclinedReasons).subscribe(evtResult => {
                if (evtResult) {
                  if (evtResult.messages && evtResult.messages.filter(x => x.status === 'Error').length === 0) {
                    this.snackBar.open('Success!', null, {
                      duration: 5000,
                      verticalPosition: 'top',
                      panelClass: ['blue-snackbar']
                    });
                  } else {
                    console.log('Error occurred while decling MFA enrollment.', evtResult.messages);
                    this.ShowError('Error', 'Error occurred while decling MFA enrollment');
                  }
                }
                else {
                  console.log('Error occurred while decling MFA enrollment.', evtResult.messages);
                    this.ShowError('Error', 'Error occurred while decling MFA enrollment');
                }
              }, err => {
                this.ShowError("Error", JSON.parse(err.Message).error.message);
              },
                () => {
                  this.dialogRef.close(true);
                });
            }
        }else{
          this.pcfError = this.showPCFOption && this.isPCFValid == false;
        }
    }

    onTabChange(event) {
        if (event.index == 2) {
            this.showSubmitAction = true;
        } else {
            this.showSubmitAction = false;
        }
    }

    openMFAEnrollment() {
        onMFAEnrollmentClick(this.configuration, this.authData, this.authData.getUserInfo().email, this.language);
    }

    clearFile() {
        this.isPCFValid = false;
        this.pcfDocument = null;
    }

    openPCFDialog() {
        const dialogRef = this.matDialog.open(PcfDialogComponent, {
            panelClass: ['sidepanel', 'animate__animated', 'animate__slideInRight'],
            width: '45%',
            height: '100%',
            data: { supplierCode: this.supplierCode, disableSelfSubmit: true },
        });

        dialogRef.afterClosed().subscribe((x) => {
            if (x && isArray(x)) {
                this.isPCFValid = true;
                this.pcfDocument = x[2][0];
                this.contacts = x[1];
                console.log(x);
            }
        });
    }

    ShowError(title: string, message: string) {
      this.translate.getAsync(message).subscribe((x: string) => {
        this.snackBar.open(x, '', {
          duration: 5000,
          verticalPosition: 'top',
          panelClass: ['red-snackbar']
        });
      });
    }
}
